/**
 * Округляет и форматирует сумму до 2 знаков после запятой
 * Формат: "1 000 000.00 USDT" (пробелы как разделители тысяч)
 * @param amount число с плавающей точкой
 * @returns строка с двумя знаками после запятой
 */
export function formatUSDT(amount: number): string {
  if (amount === 0 || amount === null) {
    return '0 USDT'
  }
  
  // Форматируем с пробелами между тысячами и точкой для десятичных
  const formattedAmount = new Intl.NumberFormat('ru-RU', {
    style: 'decimal',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    useGrouping: true,
  }).format(amount).replace(/,/g, '.')
  
  return `${formattedAmount} USDT`
}
